import styled from 'styled-components';
import { rem } from '@/styles/theme';

interface IProps {
  divider?: boolean;
}

export const Container = styled.div`
  padding-top: ${rem(16)};
`;
export const Wrapper = styled.div<IProps>`
  display: flex;
  flex-direction: column;
  gap: ${rem(6)};
  background: #ffffff;
  padding: ${rem(16)} ${rem(18)};
  ${({ divider, theme }) =>
    divider &&
    `
    padding: ${rem(40)} ${rem(18)} ${rem(16)};
    
  `}
  ${({ theme: { media } }) => media.fold`
    padding: ${rem(32)} ${rem(20)} ${rem(16)};
    gap: ${rem(6)};
  `};
`;

export const TitleWrpper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const TitleLeftWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${rem(6)};
`;
